/**
 * scroll-Handler
 */
$(function() {
  $(window).scroll(function (event) {
    var scrollPos = $(window).scrollTop();
    /*
     * submenu active setter
     */
    $(".snippet-sidebar ul li a").each(function () {
      var thiselem = $(this);
      if (
          thiselem.attr("href").search("#") != -1 &&
          $(thiselem.attr("href")).length
      ) {
        var href = $(thiselem.attr("href"));
        if (href.position().top - 100 <= scrollPos) {
          $(".snippet-sidebar ul li a").removeClass("active");
          thiselem.addClass("active");
        } else {
          thiselem.removeClass("active");
        }
      }
    });
    /*
     * sticky-nav call
     */
    if ($('.hero').length > 0) {
      var startPosition = $('.hero').outerHeight();
    } else {
      var startPosition = 600;
    }

    stickyNav(".snippet-sidebar", startPosition, $(".snippet-sidebar").parent().width());
  });
});
/**
 * sticky-nav funtion
 */
function stickyNav(classname, start_fixed_position, width) {
  var scroll = $(window).scrollTop();
  if (scroll >= start_fixed_position) {
    $(classname).css("width", width);
    $(classname).addClass("sticky");
  } else {
    $(classname).removeClass("sticky");
  }
}
